import React, { useEffect, useRef, useState } from "react";

import { useSession } from "../../contexts/SessionContext";
import translate from "../../services/Translate";
import { TruncatedTextProps } from "./TruncatedText.d";

const TruncatedText = ({ text, lines = 4, customClassName = "" }: TruncatedTextProps) => {
  const { language } = useSession();
  const ref = useRef<HTMLDivElement>(null);
  const [showFull, setShowFull] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const [lineHeight, setLineHeight] = useState(20);

  useEffect(() => {
    if (ref.current) {
      const computed = window.getComputedStyle(ref.current);
      const lineHeightPx = parseInt(computed.lineHeight || "20", 10);
      setLineHeight(lineHeightPx);

      const maxHeight = lines * lineHeightPx;
      setIsTruncated(ref.current.scrollHeight > maxHeight);
    }
  }, [text, lines]);

  return (
    <div>
      <div
        ref={ref}
        className={`text-pre-wrap overflow-hidden ${customClassName}`}
        style={!showFull ? { maxHeight: `${lines * lineHeight}px` } : {}}
      >
        {text}
      </div>

      {isTruncated && (
        <button type="button" className="btn btn-link p-0 xxs-regular" onClick={() => setShowFull((prev) => !prev)}>
          {showFull
            ? translate(language, "COMPONENTS.TRUNCATED_TEXT.VIEW_LESS")
            : translate(language, "COMPONENTS.TRUNCATED_TEXT.VIEW_MORE")}
        </button>
      )}
    </div>
  );
};

export default TruncatedText;
